import { DonutProps } from "@app/shared/metrics/MetricsDonut";
import { QesColors } from "@app/shared/qes-standards/colors";

export const mockDonutData2: DonutProps = {
  description: "",
  innerLabelString: "total gaps",
  segments: [
    {
      backgroundColor: QesColors.QesTertiaryRed2,
      description: "",
      label: "Critical",
      numberValue: 148,
    },
    {
      backgroundColor: QesColors.QesPrimaryRed,
      description: "",
      label: "High",
      numberValue: 222,
    },
    {
      backgroundColor: QesColors.QesTertiaryYellow2,
      description: "",
      label: "Medium",
      numberValue: 371,
    },
    {
      backgroundColor: QesColors.QesTertiaryGreen2,
      description: "",
      label: "Low",
      numberValue: 370,
    },
    {
      backgroundColor: QesColors.QesTertiaryBlue1,
      description: "",
      label: "Minimal",
      numberValue: 371,
    },
  ],
  title: "Priority Distribution",
};
